// Search parameters of the environments board: unknown or malformed values are dropped.

import { isKindSlug, tryParseRef } from "@cosmosai/api-client";
import { z } from "zod";
import type { EnvironmentsSearch } from "../context";

const text = z.string().trim().min(1).max(200).optional().catch(undefined);

const EnvironmentsSearchSchema = z.object({
  kind: z.string().refine(isKindSlug).optional().catch(undefined),
  project: text,
  q: text,
  refs: z
    .array(z.string().refine((ref) => tryParseRef(ref)?.version === null))
    .max(1000)
    .optional()
    .catch(undefined),
});

export const validateEnvironmentsSearch = (raw: Record<string, unknown>): EnvironmentsSearch =>
  Object.fromEntries(
    Object.entries(EnvironmentsSearchSchema.parse(raw)).filter(([, v]) => v !== undefined),
  ) as EnvironmentsSearch;
